import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminOffers from "@/pages/AdminOffers";
import AdminGate from "@/components/AdminGate";

export const Route = createFileRoute("/admin/offers")({
  head: () => seoHead("/admin/offers"),
  component: () => (
    <AdminGate><AdminOffers /></AdminGate>
  ),
});
